import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const CustomSnackbar = ({ status, setOpen, open, message }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Snackbar
        style={{
          display: 'block',
        }}
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <Alert severity={status}>{message}</Alert>
      </Snackbar>
    </>
  );
};

CustomSnackbar.propTypes = {
  status: PropTypes.any,
  setOpen: PropTypes.any,
  open: PropTypes.any,
  message: PropTypes.any,
};

export default CustomSnackbar;
